import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, ElementRef, EventEmitter, Input, Output, QueryList, SimpleChanges, forwardRef } from "@angular/core";
import { CsRadioBase } from "./cs-radio-component-interface";

@Component({
    selector: 'cs-radio-group',
    templateUrl: 'cs-radio-group-component.html',
    // the radios inside are announced as one set of choices
    host: { 'role': 'radiogroup' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsRadioGroupComponent {
  @ContentChildren(forwardRef(() => CsRadioBase), { descendants: true }) items: QueryList<CsRadioBase>;

  @Input() selected: any;
  @Output() selectedChange = new EventEmitter<any>();

  constructor(
    public elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected) {
      if (this.items) {
        this.items.forEach(item => item.refreshSelection());
      }
    }
  }

  deselectAll() {
    this.items.forEach(item => item.deselect());
  }

  select(value: any) {
    if (value !== this.selected) {
      this.selected = value;
      this.selectedChange.emit(value);
    }
    this.cdr.markForCheck();
  }
}
